export const MODEL_OPENNESS = {
    // BloombergGPT Dataset models - 按 MOF 标准分类
    // Closed: 闭源商业模型
    "GPT-4o": "Closed",
    "GPT-5": "Closed",
    "o3-mini": "Closed",
    "o3": "Closed",
    "Gemini 2.5 Flash": "Closed",
    "Grok4": "Closed",
    "Claude 4 Sonnet": "Closed",
    // Class III – Open Model: 开放模型架构、参数、技术报告、评估结果等
    "Llama-3.1-8B-Instruct": "Class III-Open Model",
    "DeepSeek Chat": "Class III-Open Model",
};

export const getModelOpenness = (modelName) => {
    return MODEL_OPENNESS[modelName] || "Unclassified";
};
